import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { BtnV2, Loader, l } from '@manychat/manyui'

import { SubscriberName } from 'common/audience/components/SubscriberName'
import { OptInSources } from 'common/audience/constants/OptInAppTypes'
import { CircleAvatar } from 'components/CircleAvatar'

export default class UserList extends React.Component {
  static propTypes = {
    users: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        user_id: PropTypes.string,
        avatar: PropTypes.string,
        optin_source: PropTypes.oneOf([
          OptInSources.DIRECT,
          OptInSources.ECHO,
          OptInSources.GT,
          OptInSources.MESSENGER,
          OptInSources.IMPORT_SUBSCRIBERS,
          OptInSources.CHANNEL_SMS,
          OptInSources.AUDIENCE,
          OptInSources.CGT,
          OptInSources.INSTAGRAM,
          OptInSources.PRIVATE_REPLY,
          OptInSources.STORY_MENTION,
          OptInSources.STORY_REPLY_TO,
          OptInSources.TELEGRAM,
        ]),
      }),
    ),
    loading: PropTypes.bool,
    hasMore: PropTypes.bool,
    onLoadMore: PropTypes.func,
  }

  loadUsers = (event) => {
    event && event.preventDefault()
    this.props.onLoadMore()
  }

  render() {
    const { users, loading, hasMore } = this.props
    return (
      <div className="p-a" style={{ minHeight: 100 }}>
        {loading && <Loader center />}

        {!loading && users.length === 0 && (
          <div className="text-center text-secondary">{l.translate('No contacts found')}</div>
        )}

        {users.map((user, id) => (
          <div
            key={user.user_id}
            className={cx('row middle', {
              'm-b': id !== users.length - 1,
            })}
          >
            <CircleAvatar className="m-r-xs col-auto" url={user.avatar} />
            <SubscriberName className="col d-inline-flex" subscriber={user} />
          </div>
        ))}

        {hasMore && (
          <div className="text-center">
            <BtnV2 variant="primary" onClick={this.loadUsers}>
              {l.translate('Load more')}
            </BtnV2>
          </div>
        )}
      </div>
    )
  }
}
